import React, { useEffect, useState } from 'react';
import Loader from 'components/loader/Loader';
import EditTestResultCard from 'containers/partials/cards/EditTestResultCard';
import {
  generatePath,
  useHistory,
  useParams,
  useRouteMatch
} from 'react-router-dom';
import {
  ROUTE_SESSIONS_ENTITY_SESSION_PERSON,
  ROUTE_SESSIONS_ENTITY_SESSION_PERSON_GLOBAL_EDIT,
  ROUTE_SESSIONS_ENTITY_SESSION_PERSON_TESTS_TESTDATA_EDIT,
  ROUTE_SESSIONS_ENTITY_SESSION_PERSONS
} from 'routes/RouteList';
import { useAbility } from '@casl/react';
import { useTestDataContext } from 'contexts/TestDataContext';
import { useSessionContext } from 'contexts/SessionContext';
import { AbilityContext } from 'Can';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import useEdit from 'hooks/utils/useEdit';
import RemoveSporterFromSessionButton from 'containers/partials/buttons/RemoveSporterFromSessionButton';
import slugify from 'slugify';
import messages from 'messages';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import GenerateMagicLinkButton from 'containers/partials/buttons/GenerateMagicLinkButton';
import GenerateMagicURLModal from 'containers/partials/modals/GenerateMagicURLModal';

const SessionPersonDataTab = () => {
  const { entityId, sessionsTab, sessionId, personId } = useParams();
  const { push } = useHistory();
  const person = useEntityContext(s => s.person);
  const { session } = useSessionContext();
  const { testDataLoading } = useTestDataContext();
  const ability = useAbility(AbilityContext);
  const { setMenuItems, clearAllContext } = useContextMenu();
  const [edit] = useEdit(
    !!useRouteMatch(
      [
        ROUTE_SESSIONS_ENTITY_SESSION_PERSON_TESTS_TESTDATA_EDIT,
        ROUTE_SESSIONS_ENTITY_SESSION_PERSON_GLOBAL_EDIT
      ],
      true
    )
  );
  const [openGenerateMagicURLModal, setOpenGenerateMagicURLModal] =
    useState(false);

  const GenerateMagicLinkBtn = () => (
    <GenerateMagicLinkButton
      menu
      person={person}
      onClick={() => setOpenGenerateMagicURLModal(true)}
    />
  );

  const RemoveSporterFromSessionBtn = () => (
    <RemoveSporterFromSessionButton
      menu
      rootEntityId={entityId}
      sessionId={session.id}
      ids={[personId]}
      onComplete={() =>
        push(
          generatePath(ROUTE_SESSIONS_ENTITY_SESSION_PERSONS, {
            entityId,
            sessionsTab,
            sessionId: session.id
          })
        )
      }
      dataQa={`${slugify(messages.menuItemSessionRemoveSporter.id.toLowerCase())}-menu`}
    />
  );

  useEffect(() => {
    const contextButtons = [];

    if (ability.can('manage', 'Sessions')) {
      contextButtons.push(<RemoveSporterFromSessionBtn />);
    }

    if (session.isRecurring && ability.can('manage', 'Sessions')) {
      contextButtons.push(<GenerateMagicLinkBtn />);
    }

    setMenuItems(contextButtons);

    return () => {
      // Cleanup action buttons and context menu items
      clearAllContext();
    };
  }, [person, ability, sessionId]);

  if (testDataLoading) {
    return <Loader />;
  }

  return (
    <>
      <EditTestResultCard
        entityId={entityId}
        personId={personId}
        edit={edit}
        rootPath={generatePath(ROUTE_SESSIONS_ENTITY_SESSION_PERSON, {
          entityId,
          sessionId,
          sessionsTab,
          personId
        })}
      />
      {openGenerateMagicURLModal && (
        <GenerateMagicURLModal
          entityId={entityId}
          person={person}
          destiny={sessionId}
          onClose={() => setOpenGenerateMagicURLModal(false)}
        />
      )}
    </>
  );
};

export default SessionPersonDataTab;
